<template>
    <div class="rao">
        <div class="search-bar">
            <transition name="fade-in-out" mode="out-in">
                <div class="search-or-info" key="search" v-if="!results.length" style="background: white;">
                    <div class="basic-search">
                        <h3 class="h3 search-by" style="color: black">Search by:</h3>
                        <form @submit.prevent id="explicit_region">
                            <ul class="form-fields list-spaced list-horizontal home-basic-search">
                                <explicit-region :owner-address-parcel-error="ownerAddressParcelError"
                                                 :region-error="regionError"
                                                 :region.sync="explicitRegionString"
                                                 :advanced-search-open="showAdvanced"
                                                 :selected-owner-address-parcel.sync="explicitOwnerAddressParcelSelected"
                                                 :owner-address-parcel.sync="explicitOwnerAddressParcel"
                                                 ref="explicitRegion"
                                                 key="homeSearch"
                                ></explicit-region>
                                <li>
                                    <input style="margin-left: 24px; background: #09312C; color: white" class="button" type="submit" value="Submit"
                                           @click="homeExplicitRegion">
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
                <div class="search-or-info" key="info" v-if="results.length">
                    <div style="padding-left: 16px;">
                        <span style="font-size: larger"><strong>Currently showing: </strong>{{ searchString }}</span>
                    </div>
                </div>
            </transition>
            <div :class="`${results.length ? 'search-options-green' : 'search-options-white'}`">
                <transition name="fade-in-out" mode="out-in">
                    <div v-if="results.length" key="edit-search">
                       <a class="button" @click="showAdvanced = true" href="#" style="background-color: #00A916;">Edit search</a>
                        <a href="#" style="margin-left: 10px" @click="clearResults">Clear search</a>
                    </div>
                    <div v-if="!results.length" key="more-options">
                        <a href="#" class="button" style="background: #00A916; color:black"  @click="showAdvanced = true">Advanced Search</a>
                    </div>
                </transition>
            </div>
        </div>

        <div class="search-results" ref="resultsAndMap">
            <transition name="fade-in-out">
                <div v-show="results.length" v-bind:class="{ 'search-panel-expanded' : expandedResults}"
                     class="search-panel" key="results-panel" ref="resultsPanel">
                    <div class="omnisearch-results">
                        <div style="margin-bottom: 10px;">
                            <div style="display: block; margin-bottom: 10px">
                                <span class="result-size-label">Result Details: &nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <div class="result-size-toggle">
                                    <span class="result-size-label">Compact</span>
                                    <label class="switch">
                                        <input type="checkbox" v-model="expandedResults">
                                        <span class="slider round"></span>
                                    </label>
                                    <span class="result-size-label">Extended</span>
                                </div>
                            </div>
                            <button :disabled="numberOfResults < 1" class="button" @click="addToCart = true">Add
                                {{ numberOfResults }} Results to Cart
                            </button>
                        </div>
                        <div class="scroll-wrapper" ref="tableScrollContainer">
                            <float-thead-table float-table-class="table-data" ref="resultTable"
                                               :scroll-container="scrollWrapper" position="fixed">
                                <thead>
                                <tr>
                                    <th>Parcel</th>
                                    <th>Owner</th>
                                    <th v-show="expandedResults">Address</th>
                                    <th v-show="expandedResults">County</th>
                                    <th v-show="expandedResults">Muni</th>
                                    <th style="width: 15px; padding-right: 24px">
                                        <input class="bigger-box" type="checkbox" @change="selectAllOrNone" checked
                                               title="select-all">
                                    </th>
                                </tr>
                                </thead>
                                <tbody id="result-table-body">
                                <tr v-for="(result, index) in results"
                                    v-on:click="selectResult(index)"
                                    v-bind:class="{ 'row-selected': index === selectedIndex }"
                                    :ref="index"
                                    :key="result.county_id + '.' + result.county_row_id">
                                    <td><a target="_blank"
                                           :href="'/cama_redir?county_id=' + result.county_id + '&rausa_id=' + result.county_row_id + '&parcel_id=' + result.parcel_id ">{{
                                            result.parcel_id
                                        }}</a></td>
                                    <td>{{ result.owner }}</td>
                                    <td v-show="expandedResults">{{ result.address }}</td>
                                    <td v-show="expandedResults">{{ result.county_name }}</td>
                                    <td v-show="expandedResults">{{ result.municipality_name }}</td>
                                    <td style="width: 15px; vertical-align: middle; padding-right: 24px;">
                                        <input v-if="result.sell" class="bigger-box select-parcel" :data-robust-id="result.robust_id"
                                               type="checkbox" @click.stop="selectDeselectParcel" checked
                                               title="add-remove">
                                    </td>
                                </tr>
                                </tbody>
                            </float-thead-table>
                        </div>
                    </div>
                </div>
            </transition>
            <online-map :results="results"
                        :center-point="centerPoint"
                        :should-replace="shouldReplace"
                        :selected-index="selectedIndex"
                        :should-zoom="shouldZoom"
                        :resize-map="resizeMap"
                        v-on:selection-changed="selectResult"
                        v-on:identify-single="identifySingle"
                        v-on:identify-multiple="identifyMultiple"
                        v-on:print-map="printMap"
                        v-on:map-loaded="checkSearchQuery"
                        v-on:finished-loading="loadingResults = false"></online-map>
            <popup-modal x-close :title="'Warning'" style="margin-top:50px;" v-show="showWarningModal" @close="showWarningModal = false">
                <template v-slot:content>
                <div class="text-center">
                    <div class="mod">
                    <p class="bd text-block">
                    Warning: Your browser size device may not be supported by ReportAll Online. We recommend using this application on a larger screen size. If you are visiting this site from a tablet or mobile device, we encourage you to use our mobile application,
                    <a href="https://s8x25.app.goo.gl/QhDw" target="_blank">LandGlide</a>.
                    </p>
                    <a
                        href="https://s8x25.app.goo.gl/QhDw"
                    >
                        <img
                            src="https://landglide.com/wp-content/themes/landglide/static/img/logo_2.svg"
                            width="171"
                            height="52"
                            target="_blank"
                            style="display: block; margin-left: auto; margin-right: auto; margin-top: 10px"
                        />
                    </a>
                    </div>
                </div>
                </template>
            </popup-modal>
        </div>

        <advanced-search
            v-if="showAdvanced"
            @close="showAdvanced = false"
            :explicit-owner-address-parcel.sync="explicitOwnerAddressParcel"
            :explicit-owner-address-parcel-selected.sync="explicitOwnerAddressParcelSelected"
            :explicit-region-string.sync="explicitRegionString"
            :text-query.sync="textQuery"
            :selected-tab.sync="selectedSearchTab"
            :advanced-search-values="advancedSearchValues"
            v-on:explicit-region="explicitRegion"
            v-on:advanced-search="advancedSearch"
            v-on:shapefile-search="shapeFileSearch"
            v-on:basic-search-emitted="basicSearch"
            v-on:basic-search="advancedBasicSearch">
        </advanced-search>

        <popup-modal :title="'Error'" v-if="showError && searchError" :x-close="true" @close="showError = false">
            <template v-slot:content>
                {{ searchError }}
            </template>
        </popup-modal>

        <popup-modal-new v-if="showLogIn" @close="showLogIn = false" :x-close="true">
            <template v-slot:content>
                <div class="layer">
                    <div class="inner">
                        <div class="mod">
                            <div class="text-block bd">
                                <p style="font-size: 34px; text-align: center; font-weight: bold;">Log in or create an account.</p>
                                <p style="text-align: center">For more information about subscribing to our National Parcel Database, <a href="/solutions/websearch" style="color: inherit;"><u>click here.</u></a></p>
                                <p style="text-align: center">If you are not a subscriber, site access is $2.99/day or $49.99/month</p>
                            </div>
                        </div>
                    </div>
                    <div class="inner">
                        <div class="mod">
                            <div style="text-align: center">
                                <a class="button" style="background-color:white; color:black; background-image: none; box-shadow: none" href="/login">Login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </popup-modal-new>


        <popup-modal :title="'Buy a Day Pass or subscribe monthly!'" v-show="showSubscribe"
                     @close="showSubscribe = false">
            <template v-slot:content>
                <div class="subscription-row">
                    <div v-if="purchasingDay" class="subscription-item">
                        <h5 class="h5">Day Pass</h5>
                        <p>Purchase a one-day access pass to all the data you need.</p>
                        <p>$2.99 per day</p>
                    </div>
                    <div v-if="!purchasingDay" class="subscription-row">
                        <div class="subscription-item">
                            <h5 class="h5">Monthly Subscription</h5>
                            <p>Save and subscribe!</p>
                            <p>$49.99 per month</p>
                        </div>
                    </div>
                </div>
                <slot v-if="purchasingDay" name="payment-form"></slot>
                <slot v-if="!purchasingDay" name="payment-form-sub"></slot>
            </template>
            <template v-slot:footer>
                <button style="margin-top: -16px; margin-left: 16px" class="button" style-color="grey"
                        @click="showSubscribe = false">
                    Cancel
                </button>
            </template>
        </popup-modal>

        <popup-modal title="Export Parcels" v-if="addToCart" @close="addToCart = false" :x-close="true">
            <template v-slot:content>
                <div class="layer">
                    <div class="inner">
                        <div class="mod">
                            <div class="bd">
                                <div style="font-size: x-large">
                                    <p>After purchasing, you can download these {{ numberOfResults }} parcels, with full
                                        attributes, in Excel, Shapefile, and KML formats.</p>
                                    <br/>
                                    <p>Pricing {{ numberOfResults }} parcels for:</p>
                                    <pre style="font-size: large">{{ searchString }}</pre>
                                </div>
                                <div style="margin-top:10px" v-if="numberOfNonSaleableParcels > 0">
                                    <table>
                                        <tbody class="accordion">
                                        <tr>
                                            <td><a href="#" class="accordion-toggle" state-open="false" @click="handleAccordion">
                                                Notice: Omitting {{numberOfNonSaleableParcels}} parcels from export from the following counties:</a>
                                            </td>
                                        </tr>
                                        <tr class="accordion-drawer"
                                            state-open="false">
                                            <td colspan="3">
                                                <table class="table-data">
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <div style="display: flex; flex-flow: wrap">
                                                                <div class="download-table-header-label" style="width:80%;">
                                                                    <span style="font-weight: bold; word-break: keep-all" v-if="nonSaleableCounties.length > 0">{{ nonSaleableCounties.map(value => value).join(', ') }}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <table class="table-data">
                                        <thead>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>Price per parcel</td>
                                            <td>Running total</td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="amortization in priceAmortization().table">
                                            <td>{{ amortization.tierText }}</td>
                                            <td>{{ amortization.tierPrice }}</td>
                                            <td>{{ amortization.price }}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight: bolder">Total</td>
                                            <td>&nbsp;</td>
                                            <td style="font-weight: bolder">{{ priceAmortization().total }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="layer">
                    <div class="inner">
                        <div class="bd">
                            <div style="text-align: left">
                                <button style-color="grey" style="border:none" class="button" @click="addToCart = false">Cancel</button>
                                <button class="button" style="border:none" @click="addRemoveCart">Add {{ numberOfResults }} Parcels to Cart</button>
                                <button class="button ok-button-disabled" :disabled="!hasSufficientReportAllOnlineCredits" @click="hasSufficientReportAllOnlineCredits ? showModal = true : null">Purchase with {{ hasSufficientReportAllOnlineCredits ? numberOfResults : reportAllOnlineCreditBalance }} REP Credits</button>
                            </div>
                            <div class="mod" v-if="hasSufficientReportAllOnlineCredits">
                                <div class="bd text-block" style="font-size: small">
                                    <p>If you have questions about your REP Credits account or to add credits to your balance, <a href="mailto:sales@reportallusa.com">email</a> our Sales team or call 216-375-3481.</p>
                                </div>
                            </div>
                            <div class="mod" v-if="!hasSufficientReportAllOnlineCredits">
                                <div class="bd text-block" style="font-size: small">
                                    <p>This account does not have sufficient REP Credits to fulfill the transaction.</p>
                                    <p>Please use the Add to Cart button to checkout with a credit card. <a href="mailto:sales@reportallusa.com">Email</a> or call our Sales team at 216-375-3481 to add REP credits to your balance.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </popup-modal>

        <popup-modal title="Confirm REP Credit Purchase" id="confirm-popup" v-if="showModal" @close="showModal = false" x-close>
            <template v-slot:content>
                <div id="confirm-msg">
                    <p>Are you sure you want to complete your REP Credit purchase?</p>
                </div>
                <div id="warning-msg" style="color:red;"></div>
                <div class="popup-footer" style="max-width: 100%;text-align: right;">
                    <slot name="footer">
                        <button style="border:none;" class="button" @click="reportAllOnlineCreditPurchase">
                            Confirm
                        </button>
                    </slot>
                </div>
            </template>
        </popup-modal>

        <loading-indicator v-if="loadingResults"></loading-indicator>

        <portal-target name="autocomplete" multiple></portal-target>
    </div>
</template>

<script>
    import OnlineMap from "./OnlineMap";
    import BasicSearch from "./BasicSearch";
    import ResultCard from "./ResultCard";
    import AdvancedSearch from "./AdvancedSearch";
    import LoadingIndicator from "./LoadingIndicator";
    import ExplicitRegion from "./ExplicitRegion";

    export default {
        name: "ReportallOnline",
        components: {ExplicitRegion, AdvancedSearch, ResultCard, BasicSearch, OnlineMap, LoadingIndicator},
        props: {
            reportAllOnlineCreditBalance: Number,
        },
        computed: {
            hasSufficientReportAllOnlineCredits() {
                return this.reportAllOnlineCreditBalance >= this.numberOfResults;
            }
        },
        data () {
            return {
                searchError: null,
                results: [],
                axios: window.axios,
                centerPoint: '',
                shouldReplace: false,
                selectedIndex: null,
                showAdvanced: false,
                loadingResults: false,
                showError: false,
                showLogIn: false,
                showSubscribe: false,
                showResultTable: false,
                showBasicSearch: true,
                showModal: false,
                showACHModal: false,
                shouldZoom: false,
                subscribeMessage: '<div class="layer">\n' +
                    '                  <div class="inner">\n' +
                    '                      <div class="mod">\n' +
                    '                          <div class="hd">\n' +
                    '                              <h2 class="h2" id="subscribe-modal-title">Subscribe now</h2>\n' +
                    '                          </div>\n' +
                    '\n' +
                    '                          <div class="text-block bd">\n' +
                    '                              <p>\n' +
                    '                                  You are just a few clicks away from finding fast and low-cost property lines\n' +
                    '                                  with parcel data and land boundaries. Instant, unlimited nationwide access to\n' +
                    '                                  search and browse is only $2.99 a day or $49.99 a month. To learn more about\n' +
                    '                                  ReportAll Online, <a href="/products">click here</a>.\n' +
                    '                              </p>\n' +
                    '                              <p>If you need to download data, additional fees apply.</p>\n' +
                    '                          </div>\n' +
                    '                      </div>\n' +
                    '                  </div>\n' +
                    '              </div>\n' +
                    '              <div class="layer">\n' +
                    '                  <div class="inner">\n' +
                    '                      <div class="mod">\n' +
                    '                          <div style="text-align: center; justify-content: space-between">\n' +
                    '                              <button class="button" id="day-button">Buy a day pass</button>\n' +
                    '                              <button class="button" id="month-button">Buy a month pass</button>\n' +
                    '                          </div>\n' +
                    '                      </div>\n' +
                    '                  </div>\n' +
                    '              </div>\n',
                subscriptionModal: null,
                purchasingDay: false,
                expandedResults: false,
                resizeMap: 0,
                searchString: '',
                ownerAddressParcelError: false,
                regionError: false,
                addToCart: false,
                priceSchedule: {
                    1: 1.99,
                    2: .99,
                    7: .50,
                    100: .25,
                    200: .15,
                    300: .12,
                    400: .10,
                    500: .05,
                },
                numberOfResults: 0,
                explicitRegionString: '',
                explicitOwnerAddressParcelSelected: 'address',
                explicitOwnerAddressParcel: '',
                textQuery: '',
                selectedSearchTab: 'Explicit Region',
                showWarningModal: false,
                advancedSearchValues: {
                    region: '',
                    trans_date_min: '',
                    trans_date_max: '',
                    sale_price_min: '',
                    sale_price_max: '',
                    bldg_sqft_min: '',
                    bldg_sqft_max: '',
                    story_height_min: '',
                    story_height_max: '',
                    ngh_code: '',
                    land_use_class: [],
                    acreage_min: '',
                    acreage_max: '',
                    calc_acreage_min: '',
                    calc_acreage_max: '',
                    school_dist_id: ''
                }
        }
    },
    mounted() {
        let maxInt = Number.MAX_SAFE_INTEGER;
        this.priceSchedule[maxInt] = .03;

        this.$refs.resultTable.$el.classList.add('table-data');

        this.$nextTick(() => {
            let searchHeight = this.$refs.resultsAndMap.clientHeight;
            let heightAdjust = 110;
            if (window.matchMedia("(max-width: 1024px) and (min-width: 600px)")) {
                heightAdjust = 130;
            }
            if(window.matchMedia("only screen and (max-width:600px)").matches) {
                this.showWarningModal = true;
            }
            this.$refs.tableScrollContainer.style.height = (searchHeight - heightAdjust) + 'px';
            window.addEventListener('resize', this.windowResizeEvent);
            window.addEventListener('resize', this.toggleWarningModalOnResize);
        });
    },
    watch: {
        expandedResults: function () {
            this.$nextTick(function () {
                this.resizeSearchPanelElements();
            });
        }
    },
    methods: {
        clearResults: function (deleteCart = true) {
            this.shouldZoom = false;
            this.results = [];
            this.searchString = '';
            this.explicitRegionString = '';
            this.explicitOwnerAddressParcelSelected = 'address';
            this.explicitOwnerAddressParcel = '';
            this.textQuery = '';
            this.selectedSearchTab = 'Explicit Region';
            this.selectedIndex = null;
            if (deleteCart)
                this.axios.delete('/store/cart/online');
            this.advancedSearchValues = {
                region: '',
                trans_date_min: '',
                trans_date_max: '',
                sale_price_min: '',
                sale_price_max: '',
                bldg_sqft_min: '',
                bldg_sqft_max: '',
                story_height_min: '',
                story_height_max: '',
                ngh_code: '',
                land_use_class: [],
                acreage_min: '',
                acreage_max: '',
                calc_acreage_min: '',
                calc_acreage_max: '',
                school_dist_id: ''
            }
            this.resizeSearchPanelElements(true);
        },

        printMap: function (props) {
            let params = {
                zoom: Math.floor(props.zoom) - 1,
                center: props.center,
            }
            if (params.zoom > 12) {
                params.ovr_map_1 = 'siteroot/Base_Layers.map'
                params.ovr_layer_1 = 'Parcels';
            }
            if (this.results.length > 0) {
                let selectedIndex = this.selectedIndex || 0;
                let selectedResult = this.results[selectedIndex];
                params.county_id = selectedResult.county_id;
                params.load_table_gid = selectedResult.county_row_id;
                params.mapName = 'Base_Layers';
                params.layerName = 'Parcels';
            }
            let url = "https://reportallusa.com/dyn/map_pdf/map_pdf.py?" + $.param(params);
            window.open(url);
        },

        scrollBarWidth: function () {
            let d = document.createElement("scrolltester");
            d.style.cssText = 'width:100px;height:100px;overflow:scroll!important;position:absolute;top:-9999px;display:block';
            document.body.appendChild(d);
            let result = d.offsetWidth - d.clientWidth;
            document.body.removeChild(d);
            return result;
        },

        scrollWrapper: function () {
            return $('.scroll-wrapper');
        },

        windowResizeEvent: function () {
            this.resizeSearchPanelElements();
        },

        selectAllOrNone: function (event) {
            let element = event.target;
            $('.select-parcel').prop('checked', element.checked === true)
            if (element.checked) {
                this.axios.put('/online/select');
                this.numberOfResults = this.results.length - this.numberOfNonSaleableParcels;
            } else {
                this.axios.delete('/online/select');
                this.numberOfResults = 0;
            }
        },

        selectDeselectParcel: function (event) {
            let element = event.target;

            if (element.checked) {
                this.axios.put('/online/select/' + element.dataset.robustId);
                this.numberOfResults++;
            } else {
                this.axios.delete('/online/select/' + element.dataset.robustId);
                this.numberOfResults--;
            }
        },

        resizeSearchPanelElements: function (animating = false) {
            let searchPanel = $('.search-panel');
            let resultTable = document.getElementById('floatTheadTable');
            let heightAdjust = 110;
            if (window.matchMedia("(max-width: 1024px) and (min-width: 600px)")) {
                heightAdjust = 130;
            }
            searchPanel.on('animationend', () => {
                setTimeout(() => {
                    let searchHeight = this.$refs.resultsAndMap.clientHeight;
                    let searchWidth = this.$refs.resultsPanel.clientWidth;
                    this.$refs.tableScrollContainer.style.height = (searchHeight - heightAdjust) + 'px';
                    this.$refs.tableScrollContainer.style.width = (searchWidth - 20) + 'px';
                    resultTable.style.width = ((searchWidth - 20) - (this.scrollBarWidth())) + 'px';
                    this.resizeMap++;
                    this.$nextTick(() => {
                        this.$refs.resultTable.reflow();
                    });
                }, 30);
                searchPanel.off('animationend');
            });
            if (!animating) {
                this.$nextTick(() => {
                    let searchHeight = this.$refs.resultsAndMap.clientHeight;
                    let searchWidth = this.$refs.resultsPanel.clientWidth;
                    this.$refs.tableScrollContainer.style.height = (searchHeight - heightAdjust) + 'px';
                    this.$refs.tableScrollContainer.style.width = (searchWidth - 20) + 'px';
                    resultTable.style.width = ((searchWidth - 20) - (this.scrollBarWidth())) + 'px';
                    this.resizeMap++;
                    this.$nextTick(() => {
                        this.$refs.resultTable.reflow();
                    });
                })
            }
            if (this.resizeMap > 10)
                this.resizeMap = 0;
        },

        toggleWarningModalOnResize() {
            if(window.matchMedia("only screen and (max-width:600px)").matches) {
                this.showWarningModal = true;
            } else {
                this.showWarningModal = false;
            }
        },

        priceAmortization: function () {
            let amortization = [];
            let costTotal = 0.0;
            let numberOfParcelsAmortized = this.numberOfResults;
            let discountKeyStrings = Object.keys(this.priceSchedule);
            let discountKeys = [];
            for (let x = 0; x < discountKeyStrings.length; ++x) {
                discountKeys.push(parseInt(discountKeyStrings[x]));
            }
            discountKeys = discountKeys.sort(function (a, b) {
                return a - b
            });

            for (let i = 0; i < discountKeys.length; ++i) {
                if (numberOfParcelsAmortized <= 0)
                    break;

                let key = parseInt(discountKeys[i]);
                let currentNumberOfParcels = Math.min(key, numberOfParcelsAmortized)
                let currentPrice = this.priceSchedule[key.toString()];

                if (i === discountKeys.length - 1)
                    currentNumberOfParcels = numberOfParcelsAmortized;

                let text = (i === 0) ? 'First' : 'Next';
                text += ' ' + currentNumberOfParcels;
                costTotal += currentNumberOfParcels * currentPrice;
                numberOfParcelsAmortized -= currentNumberOfParcels;
                amortization.push({
                    tierText: text,
                    tierPrice: '$' + currentPrice.toFixed(2),
                    price: costTotal.toFixed(2)
                });
            }
            return {table: amortization, total: costTotal.toFixed(2)};
        },

        basicSearch: function (query) {
            this.loadingResults = true;
            this.axios.post('/online/basic-search', {
                query: query
            })
                .then((response) => {
                    this.shouldZoom = true;
                    this.explicitRegionString = '';
                    this.explicitOwnerAddressParcelSelected = 'address';
                    this.explicitOwnerAddressParcel = '';
                    this.advancedSearchValues = {
                        region: '',
                        trans_date_min: '',
                        trans_date_max: '',
                        sale_price_min: '',
                        sale_price_max: '',
                        bldg_sqft_min: '',
                        bldg_sqft_max: '',
                        story_height_min: '',
                        story_height_max: '',
                        ngh_code: '',
                        land_use_class: [],
                        acreage_min: '',
                        acreage_max: '',
                        calc_acreage_min: '',
                        calc_acreage_max: '',
                        school_dist_id: ''
                    }
                    this.handleResponse(response);
                })
                .catch((error) => {
                    this.handleSearchError(error);
                });
        },

        advancedBasicSearch: function (formData) {
            this.loadingResults = true;
            this.axios.post('/online/basic-search', formData)
                .then((response) => {
                    this.checkUpdateUrlString(formData)
                    this.explicitRegionString = '';
                    this.explicitOwnerAddressParcelSelected = 'address';
                    this.explicitOwnerAddressParcel = '';
                    this.shouldZoom = true;
                    this.advancedSearchValues = {
                        region: '',
                        trans_date_min: '',
                        trans_date_max: '',
                        sale_price_min: '',
                        sale_price_max: '',
                        bldg_sqft_min: '',
                        bldg_sqft_max: '',
                        story_height_min: '',
                        story_height_max: '',
                        ngh_code: '',
                        land_use_class: [],
                        acreage_min: '',
                        acreage_max: '',
                        calc_acreage_min: '',
                        calc_acreage_max: '',
                        school_dist_id: ''
                    }
                    this.handleResponse(response)
                })
                .catch((error) => {
                    this.handleSearchError(error);
                });
        },

        robustIdSearch: function (robustId) {
            this.loadingResults = true;
            this.axios.post('/online/robust-search', robustId)
                .then((response) => {
                    this.handleResponse(response);
                })
                .catch((error) => {
                    this.handleSearchError(error);
                });
        },

        selectResult: function (index) {
            this.selectedIndex = parseInt(index);
            let container = $(this.$refs.tableScrollContainer);
            if (index !== null) {
                let row = $(this.$refs[index][0]);
                let containerTop = container.scrollTop();
                let containerBottom = containerTop + container.height();
                let elementTop = this.$refs[index][0].offsetTop;
                let elementBottom = elementTop + row.height();
                let headerOffset = 0;

                if (index > 0) {
                    // Floating header mode
                    let header = document.getElementsByClassName('floatThead-container')[0];
                    let headerTop = header.offsetTop;
                    let headerHeight = $(header).height() + headerTop;
                    elementTop -= headerHeight;
                    headerOffset = headerHeight;
                }

                if (elementTop < containerTop + headerOffset)
                    container.animate({scrollTop: elementTop}, 300);
                else if (elementBottom > containerBottom)
                    container.animate({scrollTop: elementBottom - container.height()}, 300);
            }
        },

        identifySingle: async function (x, y, replace) {
            this.loadingResults = true;
            this.axios.post('/online/identify-single/' + x + '/' + y, {replace: replace})
                .then((response) => {
                    this.shouldZoom = false;
                    this.handleResponse(response, replace);
                })
                .catch((error) => {
                    this.handleSearchError(error);
                });
        },

        handleResponse: function (response, replace = true) {
            window.store.clearAnnouncementMessageAction();
            if (this.searchError) {
                this.searchError = null;
            }
            if (replace) {
                if(response.data.response.length >= 1){
                    this.results = response.data.response;
                    this.numberOfNonSaleableParcels = response.data.nonSaleableCount;
                    this.numberOfResults = this.results.length - this.numberOfNonSaleableParcels;
                    this.nonSaleableCounties = response.data.nonSaleableCounties;
                } else {
                    this.loadingResults = false;
                }
            } else {
                this.results = this.results.concat(response.data.response);
                this.numberOfNonSaleableParcels += response.data.nonSaleableCount;
                this.numberOfResults += response.data.response.length - this.numberOfNonSaleableParcels;
                this.nonSaleableCounties += response.data.nonSaleableCounties;
            }
            if (response.data.response.length === 0) {
                window.store.setAnnouncementMessageAction("Your search returned 0 results.");
            } else {
                this.searchString = this.formatSearchString(response.data.searchString)
                this.shouldReplace = replace;
            }

            if (this.results.length === 1) {
                this.$nextTick(() => {
                    this.selectResult(0);
                });
            }

            let animating = this.results.length === 0;

            this.resizeSearchPanelElements(animating);
        },

        handleSearchError: function (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    this.showLogIn = true;
                } else if (error.response.status === 403) {
                    if (!this.subscriptionModal) {
                        this.subscriptionModal = this.flash(this.subscribeMessage, 'info', {
                            beforeDestroy: () => {
                                this.subscriptionModal = null;
                            }
                        });
                    }
                    this.$nextTick(() => {
                        $('#day-button').click(this.handleSubscriptionButtonClick);
                        $('#month-button').click(this.handleSubscriptionButtonClick);
                    });
                } else if (error.response.status === 419) {
                    this.searchError = "Your ReportAll Online session has expired. Please reload the page to continue. Sorry for the inconvenience.";
                    this.showError = true;
                } else if (error.response.status === 422) {
                    this.searchError = error.response.data.message;
                    this.showError = true;
                } else if (error.response.status === 504) {
                    this.searchError = "Your query has timed out. Sorry for the inconvenience, please try again later."
                    this.showError = true;
                } else {
                    this.searchError = "An internal server error occurred.";
                    this.showError = true;
                }
            } else if (error.request) {
                this.searchError = "There was an issue talking to our servers, please try again later.";
                this.showError = true;
            } else {
                this.searchError = error.message;
                this.showError = true;
            }

            this.loadingResults = false;
        },

        handleSubscriptionButtonClick: function (event) {
            if (this.subscriptionModal) {
                this.subscriptionModal.destroy();
            }
            this.purchasingDay = event.target.id === 'day-button';

            this.showSubscribe = true;

            this.$nextTick(() => {
                if (event.target.id === 'day-button') {
                    $('#payment-button').attr('value', 'Buy for $2.99')
                    $('#subtype').val('day');
                } else {
                    $('#payment-button').attr('value', 'Subscribe for $49.99')
                    $('#subtype').val('month');
                }
            })
        },

        identifyMultiple: async function (coords) {
            this.loadingResults = true;
            this.axios.post('/online/identify-multiple', {extent: coords})
                .then((response) => {
                    this.shouldZoom = false;
                    this.handleResponse(response);
                })
                .catch((error) => {
                    this.handleSearchError(error);
                });
        },

        explicitRegion: async function (formData) {
            this.loadingResults = true;
            this.axios.post('/online/explicit-region', formData)
                .then((response) => {
                    this.checkUpdateUrlString(formData)
                    this.textQuery = '';
                    this.shouldZoom = true;
                    this.advancedSearchValues = {
                        region: '',
                        trans_date_min: '',
                        trans_date_max: '',
                        sale_price_min: '',
                        sale_price_max: '',
                        bldg_sqft_min: '',
                        bldg_sqft_max: '',
                        story_height_min: '',
                        story_height_max: '',
                        ngh_code: '',
                        land_use_class: [],
                        acreage_min: '',
                        acreage_max: '',
                        calc_acreage_min: '',
                        calc_acreage_max: '',
                        school_dist_id: ''
                    }
                    this.handleResponse(response)
                })
                .catch((error) => {
                    this.handleSearchError(error);
                });
        },

        checkParcelAttributeLayers: async function () {
            let showLayers = true;
            await this.axios.post('/online/layer')
                .catch((error) => {
                    showLayers = false;
                    this.handleSearchError(error);
                });
            return showLayers;
        },

        homeExplicitRegion: async function () {
            this.regionError = false;
            this.ownerAddressParcelError = false;
            this.$refs.explicitRegion.$refs.regionField.classList.remove('validation', 'validation-error');
            this.$refs.explicitRegion.$refs.ownerAddressParcelField.classList.remove('validation', 'validation-error');
            if (
                this.explicitRegionString === ''
                || this.explicitRegionString.trim() === ''
            ) {
                this.regionError = true;
                this.$refs.explicitRegion.$refs.region.$refs.autocompleteInput.focus();
                this.$refs.explicitRegion.$refs.regionField.classList.add('validation', 'validation-error');
                return;
            }
            if (
                this.explicitOwnerAddressParcel === ''
                || this.explicitOwnerAddressParcel.trim() === ''
            ) {
                this.ownerAddressParcelError = true;
                this.$refs.explicitRegion.$refs.ownerAddressParcel.$refs.autocompleteInput.focus();
                this.$refs.explicitRegion.$refs.ownerAddressParcelField.classList.add('validation', 'validation-error');
                return;
            }
            let formData = $('#explicit_region').serialize();
            await this.explicitRegion(formData);
        },

        advancedSearch: async function (formData) {
            this.loadingResults = true;
            this.axios.post('/online/advanced-search', formData)
                .then((response) => {
                    this.explicitRegionString = '';
                    this.explicitOwnerAddressParcelSelected = 'address';
                    this.explicitOwnerAddressParcel = '';
                    this.textQuery = '';
                    this.shouldZoom = true;
                    this.handleResponse(response)
                })
                .catch((error) => {
                    this.handleSearchError(error);
                })
        },

        shapeFileSearch: async function (formData) {
            this.loadingResults = true;
            this.axios.post('/online/shapefile-search', formData)
                .then((response) => {
                    this.explicitRegionString = '';
                    this.explicitOwnerAddressParcelSelected = 'address';
                    this.explicitOwnerAddressParcel = '';
                    this.textQuery = '';
                    this.shouldZoom = true;
                    this.advancedSearchValues = {
                        region: '',
                        trans_date_min: '',
                        trans_date_max: '',
                        sale_price_min: '',
                        sale_price_max: '',
                        bldg_sqft_min: '',
                        bldg_sqft_max: '',
                        story_height_min: '',
                        story_height_max: '',
                        ngh_code: '',
                        land_use_class: [],
                        acreage_min: '',
                        acreage_max: '',
                        calc_acreage_min: '',
                        calc_acreage_max: '',
                        school_dist_id: ''
                    }
                    this.handleResponse(response)
                })
                .catch((error) => {
                    this.handleSearchError(error)
                });
        },

        addRemoveCart: async function () {
            this.axios.put('/store/cart/online')
                .then((results) => {
                    this.addToCart = false;
                    this.clearResults(false);
                    window.store.mergeCartItemsAction(results.data);
                    window.store.setAnnouncementMessageAction("Your parcels have been added to your cart");
                    setTimeout(() => {
                        window.store.clearAnnouncementMessageAction();
                    }, 3000)
                })
                .catch((error) => {
                    this.handleSearchError(error);
                });
        },

        reportAllOnlineCreditPurchase: function() {
            this.axios.post('/online/rep-credit-purchase', { searchString: this.searchString, numberOfResults: this.numberOfResults })
                .then((response) => {
                    window.location.href = '/online/thank-you';
                })
                .catch((error) => {
                    this.handleSearchError(error);
                });
        },

        handleAccordion: function () {
            let drawer = $('.accordion-drawer');
            let toggle = $('.accordion-toggle');
            if (typeof drawer.attr('state-open') !== 'undefined' && drawer.attr('state-open') === 'true') {
                drawer.attr('state-open', false);
                toggle.attr('state-open', false);
            } else {
                drawer.attr('state-open', true);
                toggle.attr('state-open', true);
            }
        },

        checkSearchQuery: function() {
            // Check for query string in url and handle query if present
            let searchQuery = window.location.search.substring(1);
            if(searchQuery.length >= 255) {
                window.history.pushState(null, document.title, window.location.origin+'/online');
                return;
            }
            if(searchQuery.includes('region=')) {
                this.explicitRegion(searchQuery);
            } else if(searchQuery.includes('query=')) {
                this.advancedBasicSearch(searchQuery);
            } else if(searchQuery.includes('robust_id=')) {
                this.robustIdSearch(searchQuery);
            }
        },

        checkUpdateUrlString: function (searchQuery) {
            if (searchQuery.length < 255) {
                window.history.pushState(null, document.title, window.location.origin+'/online?'+searchQuery);
            }
        },

        formatSearchString: function (searchString) {
            return searchString.length > 500 ? searchString.slice(0, 500) + '...' : searchString;
        }
    },
 }
</script>

<style scoped>
.rao {
    height: calc(100vh - 112px); /* 112px being the height of the nav-bars */
    width: 100%;
    display: flex;
    flex-direction: column;
}

.search-panel {
    width: 33%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    color: black;
    background-color: white;

    a {
        color: black;
    }
}

.search-panel-expanded {
    width: 66%;
}

.search-or-info {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}

.home-basic-search {
    justify-content: center;
    align-items: center;
    display: flex;
}

.basic-search {
    width: calc(100% - 16px);
    height: 100%;
    text-align: center;
    display: flex;
    padding-left: 16px;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
}

.search-results {
    height: calc(100% - 155px);
    display: flex;
}

.search-bar {
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    background-color: #09312C;
    border-bottom-style: solid;
    border-bottom-color: black;
    border-bottom-width: 5px;
}

.search-options-green {
    padding-bottom: 16px;
    padding-left: 16px;
    background-color: #09312C;
}

.search-options-white {
    padding-bottom: 16px;
    padding-left: 16px;
    background-color: white;
}

.search-help > p {
    text-align: center;
}

.omnisearch-results {
    width: auto;
    height: calc(100% - 10px);
    margin: 10px 0 0 10px;
    align-items: center;
    justify-items: center;
}

.omnisearch-results > p {
    text-align: center;
}

.scroll-wrapper {
    position: relative;
    padding-right: 10px;
    overflow-y: auto;
    overflow-x: hidden;
}

.result-size-toggle {
    display: inline;
}

.result-size-label {
    font-size: x-large;
}

@media only screen and (max-width: 600px) {
    .search-panel {
        display: none;
    }

    .search-bar {
        display: none;
    }

    .basic-search {
        padding-left: 0;
    }

    .search-results {
        height: 100%;
    }
}

@media only screen and (max-width: 1024px) and (min-width: 600px) {
    .search-by {
        display: none;
        color: white;
    }

    .basic-search {
        padding-left: 0;
    }

    .table-data td {
        font-size: 13px;
    }

    .table-data th {
        font-size: 14px;
    }

    .result-size-toggle {
        display: block;
        margin-top: 10px;
    }

    .result-size-label {
        font-size: large;
    }

    .button {
        font-size: 14px;
        line-height: 10px;
    }
}

hr {
    border-top: 1px solid #888;
    width: 95%;
}

.floatThead-container thead {
    background-color: white;
}


/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 24px;
    bottom: 4px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: -1px;
    left: 0;
    right: 0;
    bottom: 2px;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

#result-table-body tr:nth-child(odd) {
    background-color: #d0d5d9;
}

#result-table-body tr:hover {
    background-color: #aaa;
}

.row-selected {
    /* border: 4px solid #555; */
    background-color: #D7E0E4 !important;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(14px);
    -ms-transform: translateX(14px);
    transform: translateX(14px);
}

@supports (zoom:1.4) {
    .bigger-box {
        zoom: 1.4;
    }
}

@supports not (zoom:1.4) {
    .bigger-box {
        transform: scale(1.4);
        margin: 8px;
    }
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.fade-in-out-enter-active {
    -webkit-animation: scale-in-hor-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: scale-in-hor-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

.fade-in-out-leave-active {
    -webkit-animation: scale-out-hor-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
    animation: scale-out-hor-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2020-5-13 12:56:56
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-in-hor-left
 * ----------------------------------------
 */
@-webkit-keyframes scale-in-hor-left {
    0% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        opacity: 1;
    }
    100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        opacity: 1;
    }
}

@keyframes scale-in-hor-left {
    0% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        opacity: 1;
    }
    100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        opacity: 1;
    }
}

/* ----------------------------------------------
 * Generated by Animista on 2020-5-13 13:3:5
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-out-hor-left
 * ----------------------------------------
 */
@-webkit-keyframes scale-out-hor-left {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        opacity: 1;
    }
    100% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        opacity: 1;
    }
}

@keyframes scale-out-hor-left {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        opacity: 1;
    }
    100% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        opacity: 1;
    }
}

pre {
    font-family: sans-serif;
}
</style>
